import ActionTabs, { ActionTabsPropTypes } from './ActionTabs';

export default ActionTabs;
export { ActionTabsPropTypes };
